<template>
  <el-table :data="tableData" style="width: 100%">


    <el-table-column label="请求流水号" header-align="center" show-overflow-tooltip>
      <template #default="scope">
          <span style="margin-left: 10px">{{ scope.row.reqSeqId }}</span>
      </template>
    </el-table-column>

    <el-table-column label="身份证号" header-align="center" show-overflow-tooltip>
      <template #default="scope">
        <div class="tb_column_content">
          <span style="margin-left: 10px">{{ formatIdCard(scope.row.idCardNo) }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="手机号" align="center" show-overflow-tooltip>
      <template #default="scope">
        <div class="tb_column_content">
          <span style="margin-left: 10px">{{ scope.row.phone }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="金额(元)" align="center" show-overflow-tooltip>
      <template #default="scope">
        <div class="tb_column_content">
          <span style="margin-left: 10px">{{ formatPrice(scope.row.transAmt) }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="支付日期" header-align="center" show-overflow-tooltip>
      <template #default="scope">
<!--        <div class="tb_column_content">-->
          <span style="margin-left: 10px">{{
              formatDate(scope.row.payTime)
            }}</span>
<!--        </div>-->
      </template>
    </el-table-column>

    <el-table-column label="退款日期" header-align="center" show-overflow-tooltip>
      <template #default="scope">
<!--        <div class="tb_column_content">-->
          <span style="margin-left: 10px">{{
              scope.row.rePayTime ? formatDate(scope.row.rePayTime) : scope.row.rePayTime
            }}</span>
<!--        </div>-->
      </template>
    </el-table-column>

    <el-table-column label="支付平台" header-align="center" show-overflow-tooltip>
      <template #default="scope">
        <div class="tb_column_content">
          <span style="margin-left: 10px">{{
              scope.row.type == "0" ? "汇付" : "宝付"
            }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="公司" header-align="center" show-overflow-tooltip>
      <template #default="scope">
        <div class="tb_column_content">
          <span style="margin-left: 10px">{{
              scope.row.gong == "ht" ? "灏天" : "邦远"
            }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="订单状态" header-align="center" show-overflow-tooltip>
      <template #default="scope">
        <div class="tb_column_content">
          <span style="margin-left: 10px">{{
              formatState(scope.row.state)
            }}</span>
        </div>
      </template>
    </el-table-column>

    <el-table-column label="操作" header-align="center" min-width="280" class-name="action-column">
      <template #default="scope">
        <div class="tb_column_content action-content" style="justify-content: center">
          <el-button
              size="small"
              type="danger"
              :disabled="scope.row.state==6||scope.row.state==3 ||scope.row.state==9"
              @click="handleDelete(scope.$index, scope.row)"
          >
            退订
          </el-button>
          <el-button v-if="!scope.row.isD" size="small"
                     :disabled="scope.row.state==4||scope.row.state==6||scope.row.state==3||scope.row.state==9 ||scope.row.state==8"
                     @click="handleEdit(scope.$index, scope.row)">
            退费
          </el-button>
          <el-button v-else size="small"
                     @click="handleEdit(scope.$index, scope.row)">
            退费
          </el-button>

          <el-button size="small" color="red"
                     @click="changeDrange( scope.$index)">
            紧急
          </el-button>

        </div>
      </template>
    </el-table-column>
  </el-table>
  <div class="pagination-container">
    <el-pagination
        v-model:current-page="internalPage"
        v-model:page-size="internalSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="props.total || 0"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />
  </div>
</template>

<script lang="ts" setup>
import {defineEmits, defineProps, ref, toRefs} from 'vue';
import dayjs from 'dayjs';

// 格式化时间的函数
const formatDate = (date: string) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};


// 定义 Props 接收父组件传来的数据和方法
const props = defineProps<{
  tableData: any[]
  handleEdit: (index: number, row: any) => void
  handleDelete: (index: number, row: any) => void
  total?: number
  currentPage?: number
  pageSize?: number
}>()

const emit = defineEmits<{
  (e: 'page-change', page: number, pageSize: number): void
}>()

const internalPage = ref(props.currentPage || 1)
const internalSize = ref(props.pageSize || 10)

const handleSizeChange = (val: number) => {
  internalSize.value = val
  emit('page-change', internalPage.value, internalSize.value)
}

const handleCurrentChange = (val: number) => {
  internalPage.value = val
  emit('page-change', internalPage.value, internalSize.value)
}

const formatIdCard = (idCard: string) => {
  if (!idCard) return '';
  // 保留前3位和后3位，中间用 * 替换
  return idCard.replace(/(\d{3})\d{10}(\w{3})/, '$1**********$2');
}

const formatPhone = (phone: string) => {
  if (!phone) return '';
  // 保留前3位和后4位，中间4位用 * 替换
  return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
}

const formatPrice = (price: number) => {
  if (!price) return 0;
  // 保留前3位和后4位，中间4位用 * 替换
  return Number(price).toFixed(2);
}

const changeDrange = (index: number) => {
  tableData.value[index].isD = true;
}

const formatState = (state: string) => {
  if (!state) return '';
  if (state === "0") {
    return "支付成功"
  } else if (state === "1") {
    return "支付同步中"
  } else if (state === "2") {
    return "支付失败"
  } else if (state === "3") {
    return "发起退款"
  } else if (state === "4") {
    return "退款成功"
  } else if (state === "5") {
    return "退款失败"
  } else if (state === "6") {
    return "已解绑"
  } else if (state === "7") {
    return "订单完成"
  }else if (state === "8") {
    return "支付失败订单完成"
  }else if (state === "9") {
    return "支付失败订单已解绑"
  }
  return;
}
// 解构 props 以便在模板中使用
const {tableData, handleEdit, handleDelete} = toRefs(props)
</script>

<style scoped>
.tb_column_content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-content {
  white-space: nowrap;
  gap: 8px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  padding: 10px 0;
}
</style>
